<template>
    <div :class="['trial-section pt-min-100 pb-100', sectionClass]">
        <div class="container">
            <div :class="['section-title section-title-lg mb-0', titleClass]">
                <h2>{{ title }}</h2>
                <p :style="subtitleStyle">{{ subtitle }}</p>
                <router-link to="/contact" :class="['btn', buttonClass]">
                    {{ buttonText }}
                    <!-- <span><i class="icofont-rounded-right"></i></span> -->
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FreeTrial',
    props: {
        variant: {
            type: String,
            default: 'dark', // 'dark' or 'light'
            validator: value => ['dark', 'light'].includes(value)
        }
    },
    computed: {
        sectionClass() {
            return this.variant === 'dark' 
                ? 'bg-main page-bg page-bg-3' 
                : 'bg-light page-bg page-bg-1'
        },
        titleClass() {
            return this.variant === 'dark' 
                ? 'section-title-white' 
                : 'section-title-dark'
        },
        subtitleStyle() {
            return this.variant === 'dark' ? 'color: #fff' : 'color: #767676'
        },
        buttonClass() {
            return this.variant === 'dark' 
                ? 'main-btn main-btn-white main-btn-rounded-icon' 
                : 'main-btn main-btn-blue main-btn-rounded-icon'
        },
        title() {
            return this.$t('home.freeTrial.title')
        },
        subtitle() {
            return this.$t('home.freeTrial.subtitle')
        },
        buttonText() {
            return this.$t('home.freeTrial.button')
        }
    }
}
</script>

<style scoped>
.section-title-dark h2,
.section-title-dark p {
    color: #000;
}

.trial-section .main-btn-blue {
    background-color: #007bff;
    color: white;
    border: none;
    transition: all 0.5s ease-in-out;
}

.main-btn-blue:hover {
    background: linear-gradient(90deg, #0B71FA 0%, #FF94C8 100%);
    color: white;
}
</style>
